import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { Icon, Tooltip } from 'src/components'
import { ClickCatcher } from '../../utils'
import styles from './IconAction.scss'

/**
 * A simple icon acting like a button with a handler and a tooltip describing the action
 */
const IconAction = ({ active, disabled, tooltip, tooltipPlacement, onClick, onFocus, onBlur, ...domProps }) => (
  <Tooltip title={tooltip} popperProps={{ placement: tooltipPlacement }} disabled={disabled}>
    <ClickCatcher>
      <button
        type="button"
        className={classnames(styles.action, {
          [styles.active]: active,
          [styles.disabled]: disabled,
        })}
        disabled={disabled}
        onClick={onClick}
        onFocus={onFocus}
        onBlur={onBlur}
      >
        <Icon color={active ? 'secondary' : 'dark'} {...domProps} fixedWidth />
      </button>
    </ClickCatcher>
  </Tooltip>
)

IconAction.defaultProps = {
  size: 'md',
}

IconAction.propTypes = {
  /**
   * Whether or not the button is active
   */
  active: PropTypes.bool,
  /**
   * Whether or not the button is disabled
   */
  disabled: PropTypes.bool,
  /**
   * Tooltip to be displayed on hover
   */
  tooltip: PropTypes.node,
  /**
   * the props to be applied on the tooltip
   */
  tooltipPlacement: PropTypes.string,
  /**
   * Handler to be executed on click
   */
  onClick: PropTypes.func,
  /**
   * Handler to be executed on focus
   */
  onFocus: PropTypes.func,
  /**
   * Handler to be executed on blur
   */
  onBlur: PropTypes.func,
}

export default IconAction
